<template>
  <div style="width: 100%; height: 100%">
    <v-card
      class="custom-card bomb-card"
      style="height: inherit"
    >
      <v-card-title
        class="d-flex flex-column align-start pt-2 pb-2"
        :style="{ backgroundColor: failureAlarmValue ? `red` : `#e3eef9` }"
      >
        <div class="table-title">
          {{ input.settings.component_name }}
        </div>
      </v-card-title>

      <v-card-text class="mt-2 pt-1">
        <v-row>
          <v-col cols="4">
            <v-btn
              elevation="2"
              outlined
              block
              small
              style="background-color: #e3eef9"
              color="rgb(61, 59, 59)"
              @click="setRunOrderValue(true)"
            >
              MARCHA
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              elevation="2"
              outlined
              block
              small
              style="background-color: #e3eef9"
              color="rgb(61, 59, 59)"
              @click="setRunOrderValue(false)"
            >
              PARO
            </v-btn>
          </v-col>
          <v-col cols="4">
            <div class="centered-div">
              <v-icon
                class="mt-0"
                medium
                :color="continuousRunningValue ? `green` : `#7e827f`"
                dark
              >
                mdi-circle
              </v-icon>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "QLVNBomb",
  props: {
    input: Object,
  },

  components: {},

  computed: {
    ...mapState(["editing"]),

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
        .customized.vartable;
    },
    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
        .customized.topic_write;
    },
    continuousRunningValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_continuous_running)
        ?.value;
    },
    failureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_failure_alarm)?.value;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["doPublish"]),

    setRunOrderValue(value) {
      const variableToChange = this.vartable.find(
        (v) => v.formatted_address == this.input.customized.variable_run_order
      );
      variableToChange.value = value;
      this.doPublish({
        topic: this.write_topic,
        message: {
          address: variableToChange.address,
          value: this.adaptFormat({ type: "BIT", value }),
        },
      });
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },

    handleMediaChange() {
      const DEFAULT_MIN_COMPONENT_WIDTH = 350;
      const WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE = 96;
      const MARGIN_IN_PIXELS = 15;

      const numberOfColumns = Math.floor(window.innerWidth / DEFAULT_MIN_COMPONENT_WIDTH) || 1;
      const parentDiv = Object.values(this.$parent.$refs).find((r) => r !== undefined);
      if (parentDiv && numberOfColumns === 1) {
        parentDiv.style.paddingBottom = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.paddingRight = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.width = `${WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE}%`;
        parentDiv.style.height = "fit-content";
        parentDiv.style.top = `${[...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")].reduce(
          function (totalTop, previousBombRoot, previousBombRootIndex) {
            return (
              totalTop +
              (previousBombRootIndex < parentDiv.getAttribute("index")
                ? previousBombRoot.children[0].children[0].getBoundingClientRect().height
                : 0)
            );
          },
          0
        )}px`;
        parentDiv.style.left = `${MARGIN_IN_PIXELS}px`;
      } else if (parentDiv) {
        const bombIndex = parentDiv.getAttribute("index");
        const horizontalIndex = bombIndex % numberOfColumns;
        parentDiv.style.paddingBottom = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.paddingRight = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.width = `${
          WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE / numberOfColumns -
          (numberOfColumns - 1) * (MARGIN_IN_PIXELS / window.innerWidth)
        }%`;
        const bombRoots = [...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")];

        const maxHeightInRow = Math.max(
          ...bombRoots
            .slice(
              bombIndex - (bombIndex % numberOfColumns),
              bombIndex - (bombIndex % numberOfColumns) + numberOfColumns
            )
            .map((a) => a.children[0].children[0].getBoundingClientRect().height)
        );

        if (maxHeightInRow > parentDiv.getBoundingClientRect().height) parentDiv.style.height = `${maxHeightInRow}px`;

        parentDiv.style.top = `${bombRoots.reduce(function (totalTop, _previousBombRoot, previousBombRootIndex) {
          return (
            totalTop +
            (bombIndex >= numberOfColumns &&
            (previousBombRootIndex + 1) % numberOfColumns == 0 &&
            previousBombRootIndex < parentDiv.getAttribute("index")
              ? Math.max(
                  ...bombRoots
                    .slice(previousBombRootIndex - numberOfColumns + 1, previousBombRootIndex + 1)
                    .map((a) => a.children[0].children[0].getBoundingClientRect().height)
                )
              : 0)
          );
        }, 0)}px`;
        parentDiv.style.left = `${
          (WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE / numberOfColumns) * horizontalIndex +
          ((MARGIN_IN_PIXELS / window.innerWidth) * horizontalIndex + 1)
        }%`;
      }
    },
  },

  mounted() {
    if (!this.editing) {
      window.addEventListener("resize", this.handleMediaChange);
      this.$nextTick(() => {
        [...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")].every(
          (a) => (a.children[0].children[0].style.height = "fit-content")
        );
        window.dispatchEvent(new Event("resize"));
      });
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleMediaChange);
  },
};
</script>

<style scoped>
.theme--light.v-input >>> input,
.theme--light.v-input >>> textarea,
.v-text-field >>> .v-input__control {
  color: rgba(0, 0, 0, 0.6);
}

.v-label {
  font-size: 14px;
}

.bomb-card {
  color: rgb(61, 59, 59);
  border: solid;
  border-width: 1px;
}
</style>
